import { isAxiosError } from 'axios';
import { resources } from '@/locales';

type CodigoErro = keyof (typeof resources)['pt-BR']['erros'];

const conhecido = (c: unknown): c is CodigoErro =>
  typeof c === 'string' && c in resources['pt-BR'].erros;

/** Chave do namespace `erros` para um erro do axios: o `codigo` da API, `REDE` sem resposta, senão o genérico. */
export function mensagemDeErro(error: unknown): CodigoErro {
  if (isAxiosError(error)) {
    if (!error.response) return 'REDE';
    const codigo = error.response.data?.codigo;
    if (conhecido(codigo)) return codigo;
  }
  return 'ERRO_INESPERADO';
}
